import React, { forwardRef, useState } from 'react'
import { Alert, AlertTitle, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemText, Slide, Snackbar } from '@mui/material';
import axios from "axios"
import { Auth } from "aws-amplify";
import { useTranslation, Trans } from "react-i18next";

import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningIcon from '@mui/icons-material/Warning';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DeleteStudents({adminInfo, schoolId}) {
  const [open, setOpen] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastType, setToastType] = useState([]);
  // const [maxWidth, setMaxWidth] = useState("sm");
  const maxWidth = "sm"
  const [deleteState, setDeleteState] = useState(false);

  const { t } = useTranslation()

  // useEffect(() => {
  //   if(window.screen.width<=500){
  //     setMaxWidth("sm")
  //   }
  // }, []);
  const deleteStudents = async (adminId, testId, schoolId) => {

    Auth.currentSession()
    .then(async (data) => {
      const jwtToken = data.idToken.jwtToken;

      try {
        const deleteResponse =  await axios.delete("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/admin/"+adminId+"/students?testId="+testId+"&schoolId="+schoolId, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': jwtToken
          }
        });
        // console.log("Upload Response: ",deleteResponse.data)
        if(deleteResponse.data === "Deletion Successful!") {
          alert(t("admin.students.deleteStudentsDialogue.info_deleteSuccess"));
          setToastType(["success", "Deleted All Entries Successfully!"])
          window.location.reload()
        }
        else if(deleteResponse.data === "Not Allowed to delete student entries when recordings exist in database."){
          alert(t("admin.students.deleteStudentsDialogue.info_deleteCancelled"))
          setToastType(["error", "Deletion Aborted!"])
        }
        else{
          alert("Deletion Cancelled: \n"+deleteResponse.data)
          setToastType(["error", deleteResponse.data])
        }
        setToastOpen(true)
        setDeleteState(false)
      }
      catch (error) {
        console.log(error)
        setToastType(["error", t("commonItems.error_api_generic")])
        setToastOpen(true)
        setDeleteState(false)
      }
    })
    .catch((err) => console.log(err));
  };

  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') return
    setToastOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {

    if(!adminInfo.test){
      alert(t("commonItems.error_testNotStarted"))
      return
    }
    setDeleteState(true)
    deleteStudents(adminInfo.admin.adminId, adminInfo.test.testId, schoolId)
    // setOpen(false);
  }

  return (
    <div className="deleteStudents">
      <Button 
        onClick={handleClickOpen}
        variant="contained" color="error" startIcon={<DeleteIcon />} 
        sx={{ placeSelf: "start" }}
      >
        {t("admin.students.deleteStudentsDialogue.buttonLabel_deleteAllEntries")}
      </Button>
      <Snackbar open={toastOpen} autoHideDuration={5000} onClose={handleToastClose}>
        <Alert onClose={handleToastClose} severity={toastType[0]} sx={{ width: '100%' }}>
        {toastType[1]}
        </Alert>
      </Snackbar>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        fullWidth={true}
        maxWidth={maxWidth}
        scroll="paper"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: 'var(--new-bg-color)',
            borderRadius: '10px'
          }
        }}
      >
        <DialogTitle sx={{display: "flex", alignItems: "center", gap: "0.5rem"}}>
          <WarningIcon color="error" sx={{fontSize: "1.25rem"}}/>
          <b>{t("admin.students.deleteStudentsDialogue.title")}</b>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8
          }}
        >
          <CloseIcon />
        </IconButton>
        {false ? 
          <>
            <DialogContent>
                <Alert severity="warning" className="uploadInstructions">
                  <AlertTitle><b>{t("commonItems.info_featureNotAvailable")}</b></AlertTitle>
                </Alert>
            </DialogContent>
            <DialogActions>
              <Button color="info" variant="contained" onClick={handleClose}>{t("commonItems.buttonLabel_close")}</Button>
            </DialogActions>
          </>
        :
          <>
            {(adminInfo.test && adminInfo.test.superAdminId===24) ?
              <>
                <DialogContent>
                  <Alert severity="info">
                    <AlertTitle><b>{t("admin.students.deleteStudentsDialogue.info_KVStudentDelete")}</b></AlertTitle>
                  </Alert>
                </DialogContent>
                <DialogActions>
                  <Button color="info" variant="contained" onClick={handleClose}>{t("commonItems.buttonLabel_close")}</Button>
                </DialogActions>
              </>
            :
              <>
                <DialogContent dividers>
                    {(adminInfo.test ? adminInfo.test.status===0 : false) 
                    ?
                      <>
                        <h4 style={{paddingBottom: "0.5rem"}}>{t("admin.students.deleteStudentsDialogue.instructions_title")}</h4>
                        {/* <List dense disablePadding sx={{listStyleType: "decimal", listStylePosition: "inside"}}>
                          <ListItem disableGutters>
                            <ListItemText primary={<p>1. If any student recordings from your class have already been uploaded from the TARA App, you will not be able to delete any entries.</p>}/>
                          </ListItem>
                        </List>
                        <h4 style={{padding: "0.5rem 0"}}>If you still wish to proceed,</h4> */}
                        <List dense disablePadding sx={{listStyleType: "decimal", listStylePosition: "inside"}}>
                          <ListItem disableGutters>
                            <ListItemText primary={<p>
                              <Trans 
                                i18nKey={"admin.students.deleteStudentsDialogue.instructions_line1"}
                                values={{
                                  school: adminInfo.admin.schools.filter(item => item.id === schoolId)[0].name
                                }}
                                components={{
                                  1: <b></b>
                                }}
                              />
                            </p>}/>
                          </ListItem>
                          <ListItem disableGutters>
                            <ListItemText primary={<p>{t("admin.students.deleteStudentsDialogue.instructions_line2")}</p>}/>
                          </ListItem>
                        </List>
                      </>
                    :
                      <Alert severity="error">
                        <AlertTitle><b>{t("admin.students.deleteStudentsDialogue.error_editNotAllowed")}</b></AlertTitle>
                      </Alert>
                  }
                </DialogContent>
                <DialogActions>
                  {(adminInfo.test ? adminInfo.test.status!==0 : false) 
                  ? 
                    <Button color="info" variant="contained" onClick={handleClose}>{t("commonItems.buttonLabel_close")}</Button>
                  :
                    <>
                      <h4 style={{marginRight: "auto", paddingLeft: "1rem", fontSize: "14px"}}>{t("admin.students.deleteStudentsDialogue.footer")}</h4>
                      <Button color="info" variant="contained" onClick={handleClose}>{t("admin.students.deleteStudentsDialogue.buttonLabel_cancel")}</Button>
                      {deleteState 
                        ?
                        <Button color="error" variant="contained" disabled>{t("admin.students.deleteStudentsDialogue.buttonLabel_delete")}<CircularProgress size="1rem" color="inherit" sx={{marginLeft: "0.25rem"}}/></Button>
                        :
                        <Button color="error" variant="contained" onClick={handleDelete}>{t("admin.students.deleteStudentsDialogue.buttonLabel_delete")}</Button>
                      }
                    </>
                  }
                </DialogActions>
              </>
            }
          </>
        }
      </Dialog>
    </div>
  )
}

export default DeleteStudents